(function (angular, document, history, location, setTimeout) {
  "use strict";

  var TRANSITIONLESS_CSS_CLASS_LIFETIME_MS = 100;
  var MODAL_CLOSE_UNFOCUS_INPUT_DELAY_MS = 50;

  angular.module("Toyota.Directives").directive("tyModal", [
    "ModalService",
    function (ModalService) {
      var controller = [
        "$scope",
        "$timeout",
        "$element",
        "$attrs",
        "$rootScope",
        "CssMediaWatcher",
        "ScrollLock",
        "$analytics",
        "DebugLogger",
        "ParseBool",
        function (
          $scope,
          $timeout,
          $element,
          $attrs,
          $rootScope,
          CssMediaWatcher,
          ScrollLock,
          $analytics,
          DebugLogger,
          ParseBool
        ) {
          var ctl = this;

          var documentElement = document.documentElement;
          var $modal = $element.find("[data-ty-modal-root]");
          var $panel = $element.find("[data-ty-modal-panel]");
          var $scrollArea = $element.find("[data-ty-modal-scroll-area]");

          var cssMediaWatcher = CssMediaWatcher({
            $el: $modal,
            pseudoEl: "before",
            mediaProperty: "viewportWidth",
            mediaRegexes: {
              mobile: "^mobile$",
              desktop: "^desktop$",
            },
          });

          function init() {
            ctl.isOpen = false;
            ctl.internal = {};
            ctl.internal.urlFragmentStack = [];
            ctl.preventUrlFragment = false; // bypass odd browser navigation behaviour between react router and hash URL fragments; see SFD-158 for more info
            $scope.scrollPosition = 0;

            ctl.internal.config = {
              shouldHideFloatingHeader:
                !ParseBool($attrs.tyModalHideHeader) || ParseBool($attrs.tyModalHideFloatingHeader),
              verticallyCenterContents: ParseBool($attrs.modalVerticallyCenterContents),
              leftAlignHeader: false,
              removeHeaderClose: false,
            };
          }

          function repaint() {
            if (ctl.isOpen) {
              if (!ctl.isTransitionless) {
                $panel.one("transitionend", function () {
                  ScrollLock.lock({
                    innerScrollingTarget: $scrollArea.get(0),
                  });
                  $element[0].classList.add("is-open");
                  documentElement.classList.add("is-modal-open");
                });
              } else {
                ScrollLock.lock({
                  innerScrollingTarget: $scrollArea.get(0),
                });
                $element[0].classList.add("is-open");
                documentElement.classList.add("is-modal-open");
              }
            } else {
              $element[0].classList.remove("is-open");
              documentElement.classList.remove("is-modal-open");
              ScrollLock.unlock();
            }
          }

          function fireWillModalOpenHandlers(transitionless) {
            if (!transitionless) {
              DebugLogger.log("tyModal", ctl.modalId + ": About to fire will-modal-open (transition beginning)");
            } else {
              DebugLogger.log("tyModal", ctl.modalId + ": About to fire will-modal-open (transitionless)");
            }

            $rootScope.$broadcast("will-modal-open", ctl.modalId);
          }

          function fireDidModalOpenHandlers(transitionless) {
            if (!transitionless) {
              DebugLogger.log("tyModal", ctl.modalId + ": About to fire did-modal-open (transition ended)");
            } else {
              DebugLogger.log("tyModal", ctl.modalId + ": About to fire did-modal-open (transitionless)");
            }

            $rootScope.$broadcast("did-modal-open", ctl.modalId);
          }

          function fireWillModalCloseHandlers() {
            DebugLogger.log("tyModal", ctl.modalId + ": About to fire will-modal-close (transition beginning)");
            $rootScope.$broadcast("will-modal-close", ctl.modalId);
          }

          function fireDidModalCloseHandlers() {
            DebugLogger.log("tyModal", ctl.modalId + ": About to fire did-modal-close (transition ended)");
            $rootScope.$broadcast("did-modal-close", ctl.modalId);
          }

          function pushUrlFragment(fragment) {
            var peek = ctl.internal.urlFragmentStack.length
              ? ctl.internal.urlFragmentStack[ctl.internal.urlFragmentStack.length - 1]
              : null;

            if (peek === fragment) {
              return;
            }

            ctl.internal.urlFragmentStack.push(location.hash);
            history.replaceState(undefined, undefined, fragment);
          }

          function popUrlFragment() {
            var fragment = ctl.internal.urlFragmentStack.length ? ctl.internal.urlFragmentStack.pop() : "";

            // Case: page loads with current modal open, then the guest closes it
            if (fragment === location.hash) {
              fragment = "";
            }

            var url = fragment || location.pathname + location.search;
            history.replaceState(undefined, undefined, url);
          }

          ctl.resetScrollTop = function () {
            $element.find("[data-ty-modal-scroll-area]").scrollTop(0);
          };

          ctl.open = function (isTransitionless) {
            $scope.scrollPosition = angular.element(window).scrollTop();

            // Cancel any existing close-transition end handler
            $panel.off("transitionend", fireDidModalCloseHandlers);

            $scope.$evalAsync(function () {
              // When opening the modal, reset its own internal scrollpos
              ctl.resetScrollTop();

              fireWillModalOpenHandlers();
              ctl.trackModalOpen();

              if (!ctl.preventUrlFragment) {
                pushUrlFragment("#" + ctl.modalId);
              }

              ctl.isOpen = true;
              ctl.isTransitionless = isTransitionless;
              if (isTransitionless) {
                $timeout(function () {
                  ctl.isTransitionless = false;
                }, TRANSITIONLESS_CSS_CLASS_LIFETIME_MS);
              }

              repaint();

              if (isTransitionless) {
                fireDidModalOpenHandlers(true);
              } else {
                $panel.one("transitionend", fireDidModalOpenHandlers);
              }
            });
          };

          ctl.trackModalOpen = function () {
            $analytics.eventTrack("gaVirtualPageView", {
              page: location.origin + location.pathname + location.search + "#" + ctl.modalId,
            });
          };

          ctl.close = function () {
            $timeout(function () {
              // Cancel any existing open-transition end handler
              $panel.off("transitionend", fireDidModalOpenHandlers);

              fireWillModalCloseHandlers();
              $analytics.eventTrack("gaVirtualPageView", {
                gaUrl: location.origin + location.pathname,
              });

              if (!ctl.preventUrlFragment) {
                popUrlFragment();
              }

              ctl.isOpen = false;
              ctl.isTransitionless = false;
              repaint();

              $panel.one("transitionend", fireDidModalCloseHandlers);

              var viewportWidth = cssMediaWatcher.getCurrentMedia().viewportWidth;
              if (viewportWidth.is.mobile) {
                angular.element(window).scrollTop($scope.scrollPosition);
              }
            });

            // When we close the modal, unfocus any input which was inside the modal
            setTimeout(function () {
              if (angular.element(document.activeElement).closest($modal).length) {
                document.activeElement.blur();
              }
            }, MODAL_CLOSE_UNFOCUS_INPUT_DELAY_MS);
          };

          $scope.$on("modal-open", function (event, modalId, preventUrlFragment) {
            if (modalId !== ctl.modalId) {
              return;
            }

            ctl.preventUrlFragment = preventUrlFragment;
            ctl.open();
          });

          $scope.$on("modal-open-transitionless", function (event, modalId, preventUrlFragment) {
            if (modalId !== ctl.modalId) {
              return;
            }

            ctl.preventUrlFragment = preventUrlFragment;
            ctl.open(true);
          });

          $scope.$on("modal-close", function (event, modalId) {
            if (modalId !== ctl.modalId) {
              return;
            }

            ctl.close();
          });

          $scope.$on("modal-reset-scroll-top", function (event, modalId) {
            if (modalId !== ctl.modalId) {
              return;
            }

            ctl.resetScrollTop();
          });

          $scope.$on("modal-update-header-config", function (event, headerConfig) {
            if (headerConfig.modalId !== ctl.modalId) {
              return;
            }

            ctl.title = headerConfig.title;
            ctl.internal.config.leftAlignHeader = headerConfig.leftAlign;
            ctl.internal.config.removeHeaderClose = headerConfig.removeClose;
          });

          $scope.closeModal = function (modalId) {
            if (ctl.internal.disableClose || modalId !== ctl.modalId) {
              return;
            }

            ctl.close();

            $analytics.eventTrack("gaClick", {
              eventCategory: "button",
              eventAction: "close",
              eventLabel: location.pathname,
            });

            // Broadcast multiple events, useful for tracking individual events
            for (var x = 1; x < arguments.length; x++) {
              $rootScope.$broadcast(arguments[x], modalId);
              $rootScope.$emit(arguments[x], modalId);
            }
          };

          init();
        },
      ];

      return {
        scope: {
          modalId: "@modalId",
          headerIcon: "@modalHeaderIconId",
          title: "@modalTitle",
          hideHeader: "@tyModalHideHeader",
          showBodyCloseIcon: "@tyModalShowBodyCloseIcon",
          backgroundColour: "@modalBackgroundColour",
          rootModifierClass: "@modalRootModifierClass",
          footerId: "@modalFooterId",
        },
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "ctl",
        // prettier-ignore
        template:
          "<div class=\"ty-modal\" data-ty-modal-root data-ng-class=\"{'{{ctl.rootModifierClass}}': ctl.rootModifierClass, 'is-open': ctl.isOpen, 'is-transitionless': ctl.isTransitionless}\">" +
            '<div class="ty-modal__overlay" data-ng-click="closeModal(ctl.modalId, \'modal-exit\')"></div>' +
            '<div class="ty-modal__panel" data-ty-modal-panel data-ng-class="{\'is-vertically-centered\': ctl.internal.config.verticallyCenterContents}">' +
              '<div class="ty-modal-panel">' +
                '<div class="ty-modal-panel__head">' +
                  '<div class="ty-modal-panel-head" data-ng-hide="{{ctl.hideHeader}}">' +
                    '<span class="ty-modal-panel-head__title-icon" data-ng-if="ctl.headerIcon">' +
                      '<ty-svg-icon icon-id="{{ctl.headerIcon}}"></ty-svg-icon>' +
                    '</span>' +
                    '<span class="ty-modal-panel-head__title" data-ng-class="{\'has-left-align\': ctl.internal.config.leftAlignHeader}">{{ctl.title}}</span>' +
                    '<span class="ty-modal-panel-head__close" data-ng-hide="ctl.internal.config.removeHeaderClose" data-ng-click="closeModal(ctl.modalId, \'modal-exit\')">' +
                      '<ty-svg-icon icon-id="close"></ty-svg-icon>' +
                    "</span>" +
                  "</div>" +
                  '<div class="ty-modal-panel-floating-header" data-ng-hide="{{ctl.internal.config.shouldHideFloatingHeader}}">' +
                    '<span class="ty-modal-panel-floating-header__close" data-ng-click="closeModal(ctl.modalId, \'modal-exit\')">' +
                      '<ty-svg-icon icon-id="modal-close"></ty-svg-icon>' +
                    "</span>" +
                  "</div>" +
                "</div>" +
                '<div class="ty-modal-panel__body {{ctl.backgroundColour}}" data-ty-modal-scroll-area>' +
                  '<div class="ty-modal-panel-body" data-ng-show="{{ctl.showBodyCloseIcon}}">' +
                    '<span class="ty-modal-panel-body__close" data-ng-click="closeModal(ctl.modalId, \'modal-exit\')">' +
                      '<ty-svg-icon icon-id="close" icon-width="32" icon-height="32"></ty-svg-icon>' +
                    "</span>" +
                  "</div>" +
                  '<div data-ng-transclude class="ty-modal-panel__transclude-area"></div>' +
                "</div>" +
              '<div id={{ctl.footerId}} data-ng-if="ctl.footerId"></div>' + // SFD-145 Update this to have the proper implementation of a footer (multi-slot transclusion?)
            "</div>" +
          "</div>",
        transclude: true,
        link: function ($scope, $element, $attrs) {
          /*
           * Links to #this-modal-id should open this modal.
           *
           * Note that this will not pick up links inside of
           * React SPAs -- such links need click handlers to
           * check if any modal is registered under its particular
           * #anchor-link, and if so, show it.
           *
           * See RecallVinCheckerForm.tsx and RichText/index.tsx
           * for examples of this.
           */
          angular.element("[href=#" + $attrs.modalId + "]").on("click", function (event) {
            event.preventDefault();
            $scope.ctl.open();
          });

          if (location.hash === "#" + $scope.ctl.modalId) {
            if ($scope.ctl.modalId !== "finance-calculator") {
              $scope.ctl.open(true);
            }
          }

          ModalService.registerModal($scope.ctl.modalId);
        },
      };
    },
  ]);
})(window.angular, window.document, window.history, window.location, window.setTimeout);
